// Seed data for L+TV admin CMS modules. All values are DEMO placeholders that
// authorized staff edit through the dashboard. When a backend is connected,
// replace these with real database records.

// ---- Breaking News ----
export interface BreakingItem {
  id: string;
  headline: string;
  link: string;
  priority: "high" | "medium" | "low";
  status: "active" | "inactive";
}

export const breakingSeeds: BreakingItem[] = [
  { id: "b-1", headline: "L+TV launches new digital platform connecting viewers across Cameroon", link: "/news/ltv-launches-new-digital-platform", priority: "high", status: "active" },
  { id: "b-2", headline: "Edea municipality announces new infrastructure projects for 2026", link: "/news/edea-infrastructure-development", priority: "high", status: "active" },
  { id: "b-3", headline: "Cameroon national football team prepares for upcoming qualifier match", link: "/news/cameroon-football-qualifiers", priority: "medium", status: "active" },
  { id: "b-4", headline: "Technology summit to be held in Douala next month featuring L+TV coverage", link: "/news/technology-summit-douala", priority: "medium", status: "inactive" },
];

// ---- Careers ----
export interface JobVacancy {
  id: string;
  title: string;
  department: string;
  location: string;
  employmentType: string;
  deadline: string;
  status: "open" | "closed";
  description: string;
  requirements: string;
  responsibilities: string;
}

export const jobSeeds: JobVacancy[] = [
  { id: "j-1", title: "Video Editor", department: "Production", location: "Edea, Cameroon", employmentType: "Full-time", deadline: "2026-09-15", status: "open", description: "Edit news packages, program segments and promotional content for broadcast and digital.", requirements: "Proficiency with editing software; strong sense of visual storytelling.", responsibilities: "Assemble footage, apply graphics and sound, deliver broadcast-ready files." },
  { id: "j-2", title: "News Reporter", department: "News Department", location: "Edea, Cameroon", employmentType: "Full-time", deadline: "2026-09-20", status: "open", description: "Research, report and write news stories for TV and digital platforms.", requirements: "Strong writing and on-camera skills; fluency in French and English.", responsibilities: "Gather facts, conduct interviews and produce accurate reports." },
  { id: "j-3", title: "Broadcast Technician", department: "Technical & Broadcasting", location: "Edea, Cameroon", employmentType: "Full-time", deadline: "2026-08-30", status: "closed", description: "Operate and maintain studio, transmission and streaming equipment.", requirements: "Technical background in broadcasting or IT.", responsibilities: "Ensure reliable on-air and streaming operations." },
];

// ---- Advertising ----
export interface AdCampaign {
  id: string;
  title: string;
  placement: string;
  status: "active" | "paused" | "scheduled" | "expired";
  startDate: string;
  endDate: string;
  link: string;
  description: string;
}

export const adSeeds: AdCampaign[] = [
  { id: "ad-1", title: "Regional Business Spotlight", placement: "Website banner", status: "scheduled", startDate: "2026-09-01", endDate: "2026-09-30", link: "#", description: "Banner campaign highlighting local businesses across the Littoral region." },
  { id: "ad-2", title: "Back-to-School Promotion", placement: "TV + Website", status: "active", startDate: "2026-08-20", endDate: "2026-09-10", link: "#", description: "Multi-platform campaign for the school season." },
  { id: "ad-3", title: "Community Health Awareness", placement: "Sponsored content", status: "paused", startDate: "2026-07-01", endDate: "2026-08-31", link: "#", description: "Sponsored health awareness content." },
];

// ---- Adverts (published announcements / campaigns shown on the homepage) ----
export interface Advert {
  id: string;
  title: string;
  tagline: string;
  image: string;
  description: string;
  link: string;
  placement: string;
  marquee: boolean;
  status: "active" | "inactive";
  startDate: string;
  endDate: string;
}

export const advertSeeds: Advert[] = [
  {
    id: "ad-school-2026",
    title: "Happy 2026–2027 School Year!",
    tagline: "School is the path… excellence is the destination!",
    image:
      "https://storage.helloreaddy.io/project_files/f3582b29-89ce-4104-acc4-d71527c07beb/fa6e4e02-b37a-4c26-abd7-69c1ab373a68_compressed_WhatsApp-Image-2026-09-06-at-7.31.54-PM.webp",
    placement: "Website banner",
    marquee: true,
    status: "active",
    startDate: "2026-09-06",
    endDate: "2026-12-31",
    link: "/news",
    description:
      "To all students in Cameroon, and especially those in Sanaga-Maritime — this Monday, September 7, 2026, classrooms are opening their doors again, schoolbags are heading back to school, and a new adventure begins! A new year, new dreams, new challenges, and above all… new successes. To our dear students in Sanaga-Maritime — from preschool through secondary school — we wish you a start to the year filled with courage, discipline, perseverance, and excellence. To the teachers: thank you for your commitment and dedication to shaping the citizens of tomorrow. To the parents: best wishes for this new school year, your support and encouragement are a valuable source of strength for your children. Dear students, believe in yourselves! Work hard, respect your teachers, be disciplined, and never give up on your dreams. School is the path… excellence is the destination!",
  },
];

// ---- Partners ----
export interface Partner {
  id: string;
  name: string;
  description: string;
  website: string;
  status: "active" | "inactive";
}

export const partnerSeeds: Partner[] = [
  { id: "p-1", name: "PURE HEART GROUP", description: "Collaborating organization supporting media, community and social-impact initiatives. Listed pending official approval.", website: "#", status: "inactive" },
  { id: "p-2", name: "Local Community Network", description: "Community engagement partner for local programming and events.", website: "#", status: "active" },
];

// ---- L+TV Direct sessions ----
export interface DirectSession {
  id: string;
  title: string;
  description: string;
  presenter: string;
  category: string;
  date: string;
  startTime: string;
  endTime: string;
  source: string;
  status: "draft" | "scheduled" | "live" | "completed" | "cancelled";
}

export const directSeeds: DirectSession[] = [
  { id: "d-1", title: "Community Voices: Edea Youth Forum", description: "An interactive discussion on youth opportunities in the Littoral region.", presenter: "L+TV Direct Team", category: "Community", date: "2026-09-05", startTime: "17:00", endTime: "18:00", source: "Website Direct Stream", status: "scheduled" },
  { id: "d-2", title: "Faith Talk: Building Stronger Families", description: "A live conversation with religious leaders on family and community values.", presenter: "Pastor Thomas Nkolo", category: "Religion", date: "2026-09-12", startTime: "10:00", endTime: "11:00", source: "YouTube Live", status: "draft" },
];

// ---- Section posts (Sports / Entertainment / Religion) ----
export interface SectionPost {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  featured: boolean;
  status: "draft" | "published";
}

export const sportsSeeds: SectionPost[] = [
  { id: "sp-1", title: "Local Football League Heats Up in Edea", category: "Football", excerpt: "Clubs across the Littoral region enter a decisive phase of the season.", content: "Local clubs in and around Edea are entering a decisive phase of the season, with several teams competing for top positions.", image: "", date: "2026-08-24", featured: true, status: "published" },
  { id: "sp-2", title: "Athletics Talent Showcase Announced", category: "Athletics", excerpt: "A regional athletics showcase will spotlight emerging track and field talent.", content: "A regional athletics showcase will spotlight emerging track and field talent from across Cameroon.", image: "", date: "2026-08-22", featured: false, status: "draft" },
];

export const entertainmentSeeds: SectionPost[] = [
  { id: "en-1", title: "Rising Cameroonian Artists to Watch", category: "Music", excerpt: "A look at emerging musical talent shaping the country's sound.", content: "A new wave of Cameroonian artists is capturing attention with fresh sounds and bold creativity.", image: "", date: "2026-08-23", featured: true, status: "published" },
  { id: "en-2", title: "Youth Culture and the Digital Age", category: "Youth", excerpt: "How young Cameroonians are shaping culture through digital platforms.", content: "Young Cameroonians are using digital platforms to shape culture, commerce and community.", image: "", date: "2026-08-20", featured: false, status: "draft" },
];

export const religionSeeds: SectionPost[] = [
  { id: "re-1", title: "Biblical Teaching: Foundations of Faith", category: "Teaching", excerpt: "A weekly teaching series exploring the foundations of Christian faith.", content: "This weekly series explores foundational biblical teaching for everyday life.", image: "", date: "2026-08-25", featured: true, status: "published" },
  { id: "re-2", title: "Interview with Community Religious Leaders", category: "Interview", excerpt: "A conversation on unity, service and community wellbeing.", content: "Religious leaders discuss the role of faith in strengthening community bonds.", image: "", date: "2026-08-18", featured: false, status: "draft" },
];

// ---- Services (Photo Studio / Production) ----
export interface ServiceItem {
  id: string;
  name: string;
  description: string;
  category: string;
  image: string;
  status: "active" | "inactive";
}

export const photoStudioSeeds: ServiceItem[] = [
  { id: "ps-1", name: "Portrait Photography", description: "Professional individual and group portraits with studio lighting.", category: "Portrait", image: "", status: "active" },
  { id: "ps-2", name: "Event Photography", description: "Coverage for ceremonies, conferences and public events.", category: "Event", image: "", status: "active" },
  { id: "ps-3", name: "Studio Sessions", description: "Full studio sessions with professional backdrops and equipment.", category: "Studio", image: "", status: "inactive" },
];

export const productionSeeds: ServiceItem[] = [
  { id: "pr-1", name: "Television Production", description: "End-to-end production for broadcast programs and segments.", category: "TV", image: "", status: "active" },
  { id: "pr-2", name: "Commercial Production", description: "Professional commercials and promotional videos.", category: "Commercial", image: "", status: "active" },
  { id: "pr-3", name: "Documentary Production", description: "Long-form documentaries and in-depth storytelling.", category: "Documentary", image: "", status: "inactive" },
];

// ---- Gallery ----
export interface GalleryAlbum {
  id: string;
  name: string;
  category: string;
  description: string;
  cover: string;
  count: number;
  status: "published" | "unpublished";
}

export const gallerySeeds: GalleryAlbum[] = [
  { id: "g-1", name: "L+TV Launch Ceremony", category: "Events", description: "Highlights from the digital platform launch event.", cover: "", count: 24, status: "published" },
  { id: "g-2", name: "Studio Behind the Scenes", category: "Behind the Scenes", description: "A look inside the L+TV production studio.", cover: "", count: 18, status: "published" },
];

// ---- Pages ----
export interface CmsPage {
  id: string;
  title: string;
  slug: string;
  content: string;
  status: "published" | "draft";
}

export const pageSeeds: CmsPage[] = [
  { id: "pg-1", title: "About L+TV", slug: "about", content: "L+TV TÉLÉVISION is a television and digital media channel based in Edea, Cameroon.", status: "published" },
  { id: "pg-2", title: "Advertise With L+TV", slug: "advertise", content: "Learn about advertising opportunities across television and digital platforms.", status: "published" },
];

// ---- Newsletter ----
export interface Subscriber {
  id: string;
  name: string;
  email: string;
  date: string;
  status: "subscribed" | "unsubscribed";
}

export const subscriberSeeds: Subscriber[] = [
  { id: "n-1", name: "Alain Mbarga", email: "alain.mbarga@example.com", date: "2026-08-24", status: "subscribed" },
  { id: "n-2", name: "Rosine Etoa", email: "rosine.etoa@example.com", date: "2026-08-22", status: "subscribed" },
  { id: "n-3", name: "David Fotso", email: "david.fotso@example.com", date: "2026-08-18", status: "unsubscribed" },
];

// ---- Social Media settings (single record) ----
export interface SocialSettings {
  id: string;
  facebook: string;
  youtube: string;
  tiktok: string;
  instagram: string;
  twitter: string;
  whatsapp: string;
}

export const socialSettingsSeed: SocialSettings = {
  id: "social-links",
  facebook: "https://www.facebook.com/share/v/1QNLwDHDYx/",
  youtube: "https://youtu.be/3frgYENLWOI?si=Pj0r-UOnmA8TZ4aK",
  tiktok: "",
  instagram: "",
  twitter: "",
  whatsapp: "",
};

// ---- Custom social links (extra platforms added by the admin) ----
export interface CustomSocialLink {
  id: string;
  name: string;
  icon: string;
  url: string;
}

export const customSocialLinkSeeds: CustomSocialLink[] = [];

// ---- Website settings (single record) ----
export interface SiteSettings {
  id: string;
  siteName: string;
  tagline: string;
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  poBox: string;
  copyright: string;
}

export const siteSettingsSeed: SiteSettings = {
  id: "site-settings",
  siteName: "L+TV TÉLÉVISION",
  tagline: "The Television That Connects You",
  email: "",
  phone: "",
  whatsapp: "",
  address: "Edea, Cameroon",
  poBox: "EDEA - Cameroon",
  copyright: "© {year} L+TV TÉLÉVISION. All Rights Reserved.",
};

// ---- SEO settings (single record) ----
export interface SeoSettings {
  id: string;
  siteTitle: string;
  metaDescription: string;
  socialImage: string;
  websiteUrl: string;
  keywords: string;
}

export const seoSettingsSeed: SeoSettings = {
  id: "seo-settings",
  siteTitle: "L+TV TÉLÉVISION — The Television That Connects You",
  metaDescription:
    "L+TV TÉLÉVISION is a television and digital media channel based in Edea, Cameroon, delivering news, programs, live television, videos, entertainment, culture and community content.",
  socialImage: "",
  websiteUrl: "",
  keywords: "L+TV, television, news, Edea, Cameroon, programs, videos, broadcasting",
};